import React, { useRef, useState, useEffect } from "react";
import { subscribeChannel } from "../../../services/pusherService";
import textureN from "./modalTexture/ovsld-texture-noire.jpg";

// TODO: refactorer en un component propre et plus générique
function svgFilterElement(ieSupport = false, radius = 12) {
  return ieSupport ? (
    <svg className={"Filter-container"} width="0" height="0">
      <filter id="svgBlur">
        <feGaussianBlur stdDeviation={radius} />
      </filter>
    </svg>
  ) : null;
}

const filterHack = ieSupport => (ieSupport ? "blur(12px)" : null);

function ModalContentArticle({
  modalContent: {
    id,
    title = "",
    sub_title = "",
    media_s3_tv_filename,
    media_url_tv,
    alignment_image = "",
    video_s3_tv_filename,
    description = "",
    source = "",
    author = "",
    credit_photo = "",
    lang = ""
  }
}) {
  const ieSupport = false;
  const videoEl = useRef(null);
  const [contentOpacity, setContentOpacity] = useState(1);

  useEffect(() => {
    let channelPusher = subscribeChannel();
    channelPusher.bind("play_pause", data => {
      setContentOpacity(0);
      if (videoEl.current !== null) {
        if (!data.is_play) {
          videoEl.current.pause();
        } else {
          videoEl.current.play();
        }
      }
    });
    channelPusher.bind("stop", data => {
      setContentOpacity(1);
      setTimeout(() => {
        if (videoEl.current !== null) {
          if (data.is_poster_frame) {
            videoEl.current.pause();
            videoEl.current.currentTime = 0;
          }
        }
      }, 300);
    });
    return () => {
      channelPusher.unbind("play_pause");
      channelPusher.unbind("stop");
    };
  }, []);

  useEffect(
    () => {
      setContentOpacity(1);
    },
    [id]
  );

  return (
    <div className={`Modal-wrapper ContentType--Article ID-${id}`}>
      <div className="Modal-main">
        <div className="opacityCtrl" style={{ opacity: contentOpacity }}>
          <div className={"Modal-content"} style={{backgroundImage: `url(${textureN})`}} >
            <h1 className="title">{title}</h1>
            <p className="secondaryText">{sub_title}</p>
            <p className="primaryText">{description}</p>
            <div className="Modal-credits">
              {source ? (
                <span className="Credits-source">
                  <span className="label">source&nbsp;: </span>
                  <span className="credits-value">{source}</span>
                </span>
              ) : null}
              {author ? (
                <span className="Credits-auteur">
                  <span className="label">texte&nbsp;: </span>
                  <span className="credits-value">{author}</span>
                </span>
              ) : null}
              {credit_photo ? (
                <span className="Credits-creditPhoto">
                  <span className="label">crédit photo&nbsp;: </span>
                  <span className="credits-value">{credit_photo}</span>
                </span>
              ) : null}
              {lang ? (
                <span className="Credits-langue">
                  <span className="label">langue&nbsp;: </span>
                  <span className="credits-value">{lang}</span>
                </span>
              ) : null}
            </div>
          </div>
          <div className="Modal-media">
            <div className="Modal-media-content">
              <div
                className={`Modal-media-image ${alignment_image || "center"}`}
              >
                <img alt="" src={media_s3_tv_filename || media_url_tv} />
              </div>
            </div>
            <div
              className={`Modal-media-imageBg _is-blurred ${alignment_image ||
                "center"}`}
            >
              {svgFilterElement(ieSupport, 12)}
              <img
                src={media_s3_tv_filename || media_url_tv}
                alt={"Arrière-plan flou"}
                style={{ filter: filterHack(ieSupport) }}
              />
            </div>
          </div>
        </div>
        <div className="Modal-video-fullsize">
          <video
            className={`Modal-video-player`}
            ref={videoEl}
            src={video_s3_tv_filename}
            preload="auto"
          />
          <div className="Modal-credits">
            {source ? (
              <span className="Credits-source">
                <span className="label">source&nbsp;: </span>
                {source}
              </span>
            ) : null}
            {author ? (
              <span className="Credits-auteur">
                <span className="label">texte&nbsp;: </span>
                {author}
              </span>
            ) : null}
            {credit_photo ? (
              <span className="Credits-creditPhoto">
                <span className="label">crédit photo&nbsp;: </span>
                {credit_photo}
              </span>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
}
export default ModalContentArticle;
